<template>
  <div class="about">
    <h1>This is home page</h1>
  </div>
</template>
